import { useState } from "react";
import { Button } from "flowbite-react";
import lg2 from "../../assets/images/Footer/lg2.svg";
import sms_1 from "../../assets/images/Footer/sms_1.svg";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import "react-notifications/lib/notifications.css";

export default function Follow() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    if (!value) {
      setError("Email không được để trống.");
    } else if (!validateEmail(value)) {
      setError("Email không đúng định dạng.");
    } else {
      setError("");
    }
  };

  const handleSubmit = () => {
    if (!email) {
      setError("Email không được để trống.");
      return;
    }
    if (!validateEmail(email)) {
      setError("Email không đúng định dạng.");
      return;
    }

    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
      NotificationManager.success("Email đã được gửi thành công!");
      setEmail("");
    }, 2000);
  };

  return (
    <div className="w-full flex justify-center mx-auto container px-[20px]">
      <div className="w-full border-b border-b-[#C7C7C7] flex flex-col gap-3 py-5 md:flex-row md:justify-between pt-[50px]">
        <div className="flex flex-col gap-3 w-full md:flex-row md:items-center md:justify-between">
          <div>
            <img src={lg2} alt="lg2" className="md:w-[80px] w-[65px]" />
          </div>
          <div className="flex flex-col w-full md:w-auto gap-2 lg:flex-cols">
            <div className="text-[18px] text-[#053CC8] font-semibold mb-2">
              Cập nhật tin tức mới nhất của chúng tôi
            </div>
            <div className="flex flex-col gap-8 lg:gap-0 lg:flex-row md:flex-row">
              <div className="relative w-full items-center">
                <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                  <img src={sms_1} alt="sms_1" className="w-6 h-6" />
                </span>
                <input
                  type="text"
                  className={`block w-full pl-12 pr-4 py-2 h-14 text-gray-900 bg-white shadow-lg border rounded-lg focus:ring-0 ${
                    error ? "border-red-500" : "border-[#E2E2E2]"
                  }`}
                  placeholder="Nhập email của bạn"
                  value={email}
                  onChange={handleEmailChange}
                />
                {error && (
                  <p className="text-red-500 text-sm mt-1 ml-1 absolute left-0 top-full">
                    {error}
                  </p>
                )}
              </div>
              <div>
                <Button
                  className="flex md:h-14 md:ml-1 hover:bg-pa lg:rounded-[8px] lg:w-32 lg:whitespace-nowrap md:whitespace-nowrap w-full items-center py-1 justify-center rounded-[30px] gap-6 bg-[#053CC8]"
                  onClick={handleSubmit}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <p>Đang gửi...</p>
                  ) : (
                    <p className="px-3">Gửi tin nhắn →</p>
                  )}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <NotificationContainer />
    </div>
  );
}
